<fake-loader [timer]="1700"></fake-loader>

<router-outlet></router-outlet>
